import { IDiscovery } from '../../discovery/interfaces';
import ColorManager from '../d3/ColorManager';
import { VIZ_OPTION_IDS } from '../Constants';
import {
  ILegendDatum,
  ILegendGroupDatum,
} from '../../discovery/charts/viz-legend';

export interface ISaveLegendGroupToOpenViz {
  open: IDiscovery;
  discoveryId: string;
  updatedCustomColors: Record<string, any> & {
    colorGroup?: Record<string, string>;
  };
  updatedLegendGroupData: ILegendGroupDatum[];
  updatedLegendData: ILegendDatum[];
  removedColorNames: string[];
}

export const saveLegendGroupToOpenViz = ({
  open,
  discoveryId,
  updatedCustomColors,
  updatedLegendGroupData,
  updatedLegendData,
  removedColorNames,
}: ISaveLegendGroupToOpenViz): IDiscovery => {
  ColorManager.removeColorsFromGroup(discoveryId, removedColorNames);
  ColorManager.setCustomColors(discoveryId, updatedCustomColors);
  const options = {
    ...open.viz.options,
    [VIZ_OPTION_IDS.customColors]: JSON.stringify(updatedCustomColors),
    [VIZ_OPTION_IDS.legendGroupMetadata]: JSON.stringify(
      updatedLegendGroupData,
    ),
  };
  const viz = { ...open.viz, options };

  return {
    ...open,
    viz,
    legendData: updatedLegendData,
  } as IDiscovery;
};
